// githubLogin.js
import {
  signInWithPopup,
  signInWithRedirect
} from "firebase/auth";
import { auth, githubProvider } from "./index";

export const loginWithGithub = async () => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    // await signInWithRedirect(auth, githubProvider);
    // return null; // redirect flow

    const result = await signInWithPopup(auth, githubProvider);
    return result.user;
  } else {
    const result = await signInWithPopup(auth, githubProvider);
    return result.user;
  }
};
